import React from 'react';

import { Button } from 'components/v2/Buttons/Button/Button';
import { Modal } from 'components/v2/Modal/Modal';
import { utils } from 'kb-shared';

import { InsuranceFormNotLoadedModalProps } from './InsuranceFormNotLoadedModal.types';

const { KBContacts } = utils;

export const InsuranceFormNotLoadedModal = (props: InsuranceFormNotLoadedModalProps) => {
  const { modalVisible, onLoadDataAgain } = props;

  if (!modalVisible) return null;

  return (
    <Modal
      open={modalVisible}
      onCancel={onLoadDataAgain}
      title="Unable to load data"
      closable={false}
    >
      <span>
        We are sorry, we were unable to load the data needed to fill this form.
        <br />
        Please try to load the data again, or contact us at{' '}
        <a className="link" href={`mailto:${KBContacts.navigatorEmail}`}>
          {KBContacts.navigatorEmail}
        </a>
        .
      </span>
      <Button label="Load again" onClick={() => onLoadDataAgain()} />
    </Modal>
  );
};
